<h3 mat-dialog-title>Complete Current Load</h3>

<div>Do you want to complete {{ data.driver.name }}'s current load to {{ data.driver.currentOrderDestination }}?</div>
<div class="flex flex-col gap-1">
  <button class="w-full" mat-button color="primary" (click)="completeLoad()">Complete Current Load</button>
  <button class="w-full" mat-button color="primary" (click)="cancelLoad()">Cancel Current Load</button>
  <button class="w-full" mat-button color="warn" (click)="goBack()">Go Back</button>
</div>
